// Must come first: pdf.js calls newer runtime APIs than our build target has.
import "@/lib/browser-shims";

import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// import "@follosoft/react-components/src/styles/globals.css";
import "@/styles/local.css";
import "@/i18n";
// import * as Sentry from "@sentry/react";

import App from "./App.tsx";
import { Provider } from "./provider";
import { initSentry } from "./lib/sentry.ts";
import { initEnv } from "./lib/env.ts";

initSentry();

initEnv();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <Provider>
      <App />
    </Provider>
  </BrowserRouter>
);
